<template>
  <div class="user-avatar-dropdown">
    <router-link to="/ziliao/index" class="common-user-name">
      <i class="iconfont icon-bianzu25" style="font-size: 20px"></i>
      {{ userName }}
    </router-link>
    <!-- <Button type="text" icon="ios-arrow-forward" sytle="color:#fff;">退出</Button> -->
    <span @click="logout" style="margin-left: 20px; font-size: 14px; padding-right: 6px; cursor: pointer">退出</span>
    <!-- <Dropdown @on-click="handleClick">
      <Badge>
        <i class="iconfont icon-geren"></i>
        <span class="common-user-name">{{ userName }}</span>
      </Badge>
      <Icon :size="18" type="md-arrow-dropdown"></Icon>
      <DropdownMenu slot="list">
        <DropdownItem name="user">个人信息</DropdownItem>
        <DropdownItem name="company" v-if="mode == 1">企业信息</DropdownItem>
        <div class="logout-line"></div>
        <DropdownItem name="logout">退出登录</DropdownItem>
      </DropdownMenu>
    </Dropdown> -->
  </div>
</template>

<script>
import './user.less';
import util from '@/libs/util';
import TUIChatEngine from '@tencentcloud/chat-uikit-engine';
import { mapActions } from 'vuex';
export default {
  name: 'User',
  props: {
    userAvatar: {
      type: String,
      default: ''
    },
    userName: {
      type: String,
      default: ''
    },
    mode: {
      type: [String, Number]
    }
  },
  methods: {
    ...mapActions(['handleLogOut']),
    logout() {
      this.$eventBus.$emit('closeChat')
      this.$Modal.confirm({
        title: '确定',
        content: '<p>确认要退出登录</p>',
        onOk: () => {
          this.handleLogOut().then(() => {
            // util.timLogout();
            // this.$router.push({
            //   name: 'login'
            // });
          });
          TUIChatEngine.logout();
        },
        onCancel: () => {}
      });
    },
    goCompany() {
      this.$router.push({
        name: 'mycompany-info'
      });
    },
    goUser() {
      this.$router.push({
        name: 'ziliaoIndex'
      });
    },
    handleClick(name) {
      switch (name) {
        case 'logout':
          this.logout();
          break;
        case 'company':
          this.goCompany();
          break;
        case 'user':
          this.goUser();
          break;
      }
    }
  }
};
</script>
